/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { DeployParams } from 'src/app/deployParams';
import { AffiliateRole } from 'src/app/ticket-manager/models/util/tmEnums';
import { ErrorLevel, ErrorType } from 'src/app/models/enums';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { LoaderService } from '../loader.service';
import { NotificationService } from '../notification.service';
import { StorageService } from '../util/storage.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';
import { IAuthenticateResponse } from 'src/app/ticket-manager/models/user/authenticateResponse.interface';
import { environment } from 'src/environments/environment';

// import { User } from '../Model/user';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private storageService: StorageService, private loaderService: LoaderService, private notificationService: NotificationService, public router: Router, private authService: AuthenticationService) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add authorization header with jwt token if available
    const usernameString = this.storageService.userName ? this.storageService.userName.toString() : '';
    const userLang = this.storageService.language;
    const languageCulture = LocaleHelper.cultureName[userLang];
    const userSBToken = this.storageService.authToken ? this.storageService.authToken : '';
    const tmUser = this.storageService.userTM;
    const jwtToken = this.storageService.affiliateJwtToken;
    const affiliate = this.storageService.affiliate;
    if (affiliate && this.authService.loggedAffiliate && this.authService.loggedAffiliate.affiliateId !== affiliate.affiliateId) {
      this.authService.logout();
      return of(null);
    }

    // console.log('JWT userLanguage: ' + this.storageService.language);
    // console.log('JWT languageCulture: ' + languageCulture);
    // console.log('Office: ' + DeployParams.BETWEB_OFFICE_FOR_SPORT_ORDER_ID);
    // console.log('Office: ' + environment.betWebOfficeId);
    // console.log('Office: ' + DeployParams.BETPORT_ORDER_ID);
    // FOR TM CASHIER -- OLD
    if (tmUser && tmUser.isC && tmUser.loggedOffice) {
      request = request.clone({
        setHeaders: {
          Language: languageCulture,
          AuthorizationToken: tmUser.token,
          OfficeId: tmUser.loggedOffice.id.toString(),
          UserId: tmUser.userId.toString()
        }
      });
    } else if (!affiliate) {
      if (usernameString !== '' && userSBToken !== '') {
        request = request.clone({
          setHeaders: {
            Language: languageCulture,
            'SB-Token': userSBToken,
            'PL-ID': usernameString,
            // OfficeId: DeployParams.BETWEB_OFFICE_FOR_SPORT_ORDER_ID.toString(),
            OfficeId: environment.betWebOfficeId.toString(),
            UserId: usernameString
          }
        });
      } else {
        if (usernameString !== '') {
          request = request.clone({
            setHeaders: {
              'PL-ID': usernameString ? usernameString : '',
              Language: languageCulture,
              OfficeId: environment.betWebOfficeId.toString(),
            },
          });
        } else {
          if (userSBToken !== '') {
            request = request.clone({
              setHeaders: {
                'SB-Token': userSBToken ? userSBToken : '',
                Language: languageCulture,
                // OfficeId: DeployParams.BETWEB_OFFICE_FOR_SPORT_ORDER_ID.toString(),
                OfficeId: environment.betWebOfficeId.toString(),
              },
            });
          } else {
            request = request.clone({
              setHeaders: {
                Language: languageCulture,
                // OfficeId: DeployParams.BETWEB_OFFICE_FOR_SPORT_ORDER_ID.toString(),
                OfficeId: environment.betWebOfficeId.toString(),
              },
            });
          }
        }
      }
    } else {
      request = request.clone({
        setHeaders: {
          Language: languageCulture,
          // OfficeId: request.url.startsWith(DeployParams.SPORTBOOK_BASE_URL) ? environment.betWebOfficeId.toString() : DeployParams.BETWEB_OFFICE_FOR_SPORT_ORDER_ID.toString(),
          OfficeId: environment.betWebOfficeId.toString(),
        },
      });
    }

    if (affiliate) {
      request = this.addTokenAndContent(request, jwtToken, languageCulture, affiliate);
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          return event;
        }
      }),
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            if (tmUser) {
              localStorage.removeItem('tmUser');
              this.router.navigate(['/login']);
            }
            if (this.storageService.affiliate && !request.url.includes('logOut')) {
              return this.handle401Error(request, next, languageCulture, affiliate);
            }
            this.loaderService.showHideLoader(false);
            this.storageService.authToken = null;
            this.storageService.userName = null;
            this.storageService.freeBetBalance = null;
            this.storageService.accountBalance = null;

            const notification = {
              title: DynamicTranslations.notification_title,
              message: DynamicTranslations.notification_LoginFailedWrongToken_ErrorMessage,
              errorLevel: ErrorLevel.Notification,
              errorType: ErrorType.Reload
            } as ICustomNotification;
            this.notificationService.forwardDataToNotification(notification);
            this.router.navigate(['/betting/prematch']);
            // CALL LOGOUT
            // sessionStorage.removeItem('currentUser');
            // if (this.router.url === '/login') {
            //   return observableThrowError(error);
            // }
            return observableThrowError(error);
          } else {
            if (error.status === 403 && this.authService.loggedAffiliate) {
              this.authService.logout();
            } else {
              return observableThrowError(error);
            }
          }
        } else {
          return observableThrowError(error);
        }
      }),
    );
  }

  private addTokenAndContent(request: HttpRequest<any>, jwtToken: string, languageCulture: string, affiliate: IAffiliate): HttpRequest<any> {

    return request.clone({
      setHeaders: {
        Language: languageCulture,
        Authorization: 'Bearer ' + `${jwtToken}`,
        // OfficeId:  DeployParams.BETWEB_OFFICE_FOR_SPORT_ORDER_ID.toString(),
        UserId: affiliate.affiliateId.toString()
      }
    });
  }


  // private addContentType(request: HttpRequest<any>, token: string) {
  //   return request.clone({
  //     setHeaders: {
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'Content-Type': 'application/json',
  //     }
  //   });
  // }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler, languageCulture: string, affiliate: IAffiliate) {

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((authResponse: IAuthenticateResponse) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(authResponse.jwtToken);
          return next.handle(this.addTokenAndContent(request, authResponse.jwtToken, languageCulture, affiliate));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => next.handle(this.addTokenAndContent(request, jwt as string, languageCulture, affiliate))));
    }
  }
}
